import type { AccessMode, PaywallOrigin } from '../../hooks/useSubscriptionGate';

export interface PaywallCopy {
  title: string;
  description: string;
  ctaLabel: string;
  /** `checkout` leva a `/assinatura`; `portal` abre o portal do Stripe. */
  ctaKind: 'checkout' | 'portal';
}

/** O que a assinatura destrava. Mesma lista em todas as superfícies. */
export const PAYWALL_BENEFITS: readonly string[] = [
  'Correção por IA critério a critério, com trechos da sua resposta comentados',
  'Chat com a IA sobre a sua correção',
  'Dashboard de progresso, radar de competências e insights',
];

const FREE_TITLE_BY_ORIGIN: Record<PaywallOrigin, string> = {
  self_grade: 'Assine para corrigir com IA',
  chat: 'Assine para conversar com a IA',
  dashboard: 'Assine para acompanhar seu progresso',
  competencies: 'Assine para ver suas competências',
  history_compare: 'Assine para comparar suas tentativas',
};

const FREE_DESCRIPTION_BY_ORIGIN: Record<PaywallOrigin, string> = {
  self_grade:
    'A autocorreção pelo espelho continua gratuita. A correção por IA vai além: ' +
    'avalia cada critério e comenta trechos da sua resposta.',
  chat: 'O chat com a IA sobre a sua correção faz parte da assinatura.',
  dashboard:
    'Seus simulados e o histórico continuam gratuitos. O acompanhamento de ' +
    'desempenho faz parte da assinatura.',
  competencies:
    'O radar de competências, a evolução por competência e a matriz de ' +
    'desempenho fazem parte da assinatura.',
  history_compare: 'O comparativo entre tentativas faz parte da assinatura.',
};

const FREE_FALLBACK: PaywallCopy = {
  title: 'Assine para desbloquear',
  description:
    'Este recurso faz parte da assinatura. Fazer simulados, autocorrigir pelo ' +
    'espelho e ver o histórico continuam gratuitos.',
  ctaLabel: 'Ver assinatura',
  ctaKind: 'checkout',
};

/**
 * Copy do paywall por estado de acesso. `READ_ONLY` (inadimplente) NUNCA vê
 * copy de "assine" nem CTA de checkout: quem já tem assinatura pendente
 * precisa regularizar no portal — cobrar de novo criaria uma segunda cobrança.
 */
export function resolvePaywallCopy(accessMode: AccessMode, origin?: PaywallOrigin): PaywallCopy {
  if (accessMode === 'READ_ONLY') {
    return {
      title: 'Regularize seu pagamento',
      description:
        'Sua assinatura está com pagamento pendente. Regularize para voltar a ' +
        'usar a correção por IA, o chat e o acompanhamento de desempenho.',
      ctaLabel: 'Regularizar pagamento',
      ctaKind: 'portal',
    };
  }

  if (!origin) return FREE_FALLBACK;

  return {
    title: FREE_TITLE_BY_ORIGIN[origin] ?? FREE_FALLBACK.title,
    description: FREE_DESCRIPTION_BY_ORIGIN[origin] ?? FREE_FALLBACK.description,
    ctaLabel: 'Ver assinatura',
    ctaKind: 'checkout',
  };
}
